import { ChangePasswordProps } from '@vsf-enterprise/sapcc-api';
import { Context } from '@vue-storefront/core';
import { getActiveUserId } from '../../../helpers';
import { ChangeUserPasswordProps, User } from '../../../types';

export const changeUserPassword = async (
  context: Context,
  params: ChangeUserPasswordProps
): Promise<User> => {
  const {
    $sapcc: {
      config: { $cookies }
    }
  } = context;
  const userId: string = getActiveUserId($cookies);
  const changePasswordParams: ChangePasswordProps = {
    userId,
    ...params
  };
  return context.$sapcc.api.changePassword(changePasswordParams);
};
